import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTransitionNavigate } from './PageTransition';
import { BrandMark, Wordmark } from './BrandMark';
import { Hoverable } from './Hoverable';
import { PrimaryButton } from './ui';
import { useIsDesktop } from '../hooks/useMediaQuery';
import { color, font, maxWidth } from '../styles/tokens';

const NAV = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Honing Solutions', to: '/honing' },
  { label: 'Products', to: '/products' },
  { label: 'Contact', to: '/contact' },
];

// Treat a nav item as active when the current path starts with its target
// (so /products/std-stone still highlights "Products").
const isActive = (pathname, to) => pathname === to || pathname.startsWith(to + '/');

export const Header = () => {
  const navigate = useTransitionNavigate();
  const { pathname } = useLocation();
  const desktop = useIsDesktop();
  const [menuOpen, setMenuOpen] = useState(false);

  const go = (to) => {
    setMenuOpen(false);
    navigate(to);
  };

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 60,
        background: 'rgba(7,9,14,.72)',
        backdropFilter: 'saturate(1.4) blur(14px)',
        WebkitBackdropFilter: 'saturate(1.4) blur(14px)',
        borderBottom: '1px solid rgba(255,255,255,.07)',
      }}
    >
      <div
        style={{
          maxWidth,
          margin: '0 auto',
          padding: '0 28px',
          height: 76,
          display: 'flex',
          alignItems: 'center',
          gap: 22,
        }}
      >
        <button
          onClick={() => go('/')}
          aria-label="V-Tech home"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <img src='/logo192.png' height={36} />
          {/* <BrandMark size={36} /> */}
          <Wordmark />
        </button>

        {desktop && (
          <>
            <nav style={{ display: 'flex', gap: 2, marginLeft: 'auto', alignItems: 'center' }}>
              {NAV.map((item) => {
                const on = isActive(pathname, item.to);
                return (
                  <Hoverable
                    key={item.to}
                    as="button"
                    onClick={() => go(item.to)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '10px 14px',
                      borderRadius: 999,
                      font: `500 14px ${font.display}`,
                      color: on ? color.accent : color.textMuted,
                      letterSpacing: '.01em',
                      transition: 'color .2s',
                    }}
                    hoverStyle={{ color: color.text }}
                  >
                    {item.label}
                  </Hoverable>
                );
              })}
            </nav>
            {/* <PrimaryButton
              onClick={() => go('/contact')}
              style={{ marginLeft: 16, padding: '12px 22px', font: `600 14px ${font.display}`, boxShadow: '0 8px 30px -6px rgba(77,141,255,.6)' }}
            >
              Request a Quote
            </PrimaryButton> */}
          </>
        )}

        {!desktop && (
          <button
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Menu"
            aria-expanded={menuOpen}
            style={{
              marginLeft: 'auto',
              width: 46,
              height: 46,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: 5,
              background: 'none',
              border: '1px solid rgba(255,255,255,.14)',
              borderRadius: 12,
              cursor: 'pointer',
            }}
          >
            <span style={{ height: 2, background: color.text, borderRadius: 2 }} />
            <span style={{ height: 2, background: color.text, borderRadius: 2 }} />
            <span style={{ height: 2, background: color.text, borderRadius: 2 }} />
          </button>
        )}
      </div>

      {!desktop && menuOpen && (
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,.08)',
            background: '#0b0e15',
            padding: '12px 28px 20px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          {NAV.map((item) => {
            const on = isActive(pathname, item.to);
            return (
              <button
                key={item.to}
                onClick={() => go(item.to)}
                style={{
                  background: on ? 'rgba(77,141,255,.12)' : 'none',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  padding: '14px 14px',
                  borderRadius: 12,
                  font: `500 16px ${font.display}`,
                  color: on ? color.accent : '#cdd4e0',
                }}
              >
                {item.label}
              </button>
            );
          })}
          {/* <button
            onClick={() => go('/contact')}
            style={{
              marginTop: 12,
              background: color.accent,
              color: color.bg,
              border: 'none',
              borderRadius: 12,
              padding: 15,
              font: `600 15px ${font.display}`,
              cursor: 'pointer',
            }}
          >
            Request a Quote
          </button> */}
        </div>
      )}
    </header>
  );
};
